import styles from "./styles.scss";
import { PropsWithChildren } from "react";
import clsx from "clsx";
import { TabProps } from "./types";

export const Tab = ({
  isActive,
  className,
  children,
  as: TabTag = "div",
  onClick,
}: PropsWithChildren<TabProps>) => {
  return (
    <TabTag
      aria-selected={isActive}
      className={clsx(styles.tab, className)}
      onClick={onClick}
    >
      {children}
    </TabTag>
  );
};
